export function onRouterTransitionStart(url: string) {
  const destination = new URL(url, window.location.href)
  const current = new URL(window.location.href)
  const isSameUrl =
    destination.origin === current.origin &&
    destination.pathname === current.pathname &&
    destination.search === current.search

  window.dispatchEvent(
    new CustomEvent('navigation-progress-start', {
      detail: { isSameUrl },
    }),
  )
}
